import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const tg = window.Telegram?.WebApp;
tg?.ready();
tg?.expand();

// Register the service worker for offline app-shell + last-seen data caching.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => { /* SW optional */ });
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
